(function() {
'use strict';

angular
    .module('TR')
    .service('multiSectorSearch', multiSectorSearch);

function multiSectorSearch($http,
                            occupancyService,
                            tripService,
                            multiSectorSearchValidator) {
    const url = 'website/flights/';
    const cache = {};

    const service = { search, validateSearchCriteria, getSearchResults, filter };

    function search(tripId, params) {
        const { legs } = params;
        const occupancy = occupancyService.getOccupancy()[0];

        const req = {
            Adults: occupancy.Adults,
            AvailabilitySearchId: tripId,
            ChildAges: occupancy.ChildAges,
            Destination: {},
            DomainId: TRPCONFIG.Domain.DomainId,
            FlightRoutes: legs.map(leg => ({
                DepartureDate: leg.DepartureDate,
                DepartureAirport: leg.DepartureAirport.Code,
                DestinationAirport: leg.DestinationAirport.Code,
                Cabin: leg.Cabin
            }))
        };

        tripService.recordMultiFlightSearch(tripId, req);

        const prom = $http.post(`${url}multisectorsearch`, req)
            .then(res => res.data);

        cache[tripId] = prom;

        return prom;
    }

    function validateSearchCriteria(params) {
        return multiSectorSearchValidator.validate(params.legs);
    }

    function getSearchResults(tripId, AvailabilitySearchId) {
        if (tripId in cache) {
            return cache[tripId];
        }

        const prom = filter(AvailabilitySearchId);

        cache[tripId] = prom;
        return prom;
    }

    function filter(availabilitySearchId, filters) {
        const req = {
            AvailabilitySearchId: availabilitySearchId,
            MultiSectorFilterCriteria: {
              SectorIdentifiers: filters
            }
        };

        return $http.post(`${url}multisectorsearchfromsession`, req)
            .then(res => res.data);
    }


    return service;
}
})();
